import { useFeatureStore } from '../stores/feature-store';
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { FEATURE_FLAGS } from '../constants/feature-flags';
import type { FeatureFlag } from '../types/feature-flag.type';

export class FeatureGuard {
  /** Creates a route guard that redirects if the feature is disabled. */
  static routeGuard =
    (key: FeatureFlag, fallback = 'base-home') =>
    (
      _to: RouteLocationNormalized,
      _from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      this.isEnabled(key) ? next() : next({ name: fallback });
    };

  /** Checks if a feature is enabled in the feature store. */
  static isEnabled(key: FeatureFlag): boolean {
    const store = useFeatureStore();
    return store.isEnabled(key);
  }

  /** Checks if a feature key is allowed for navigation links. */
  static isFeatureAllowed(key: string): boolean {
    const featureKeys: FeatureFlag[] = [
      FEATURE_FLAGS.BATCH_AGENT,
      FEATURE_FLAGS.BATCH_LEGACY,
      FEATURE_FLAGS.BUREAU_COMPOSER,
    ];
    if (!featureKeys.includes(key as FeatureFlag)) {
      return true;
    }
    return this.isEnabled(key as FeatureFlag);
  }
}

export default FeatureGuard;
